import { useQuery } from "@tanstack/react-query";
import { PROOFING_FLOW_APP_ID } from "@/config";
import { v2GroupsList } from "@/usersAndProjects-client/sdk.gen";
import type { Groups } from "../entities";

/**
 * Fetch all groups (suppliers)
 */
export interface UseFetchSuppliersResult {
  suppliers: Groups | null;
  isLoading: boolean;
  error: Error | null;
}

export const useFetchSuppliers = (options?: { enabled?: boolean }): UseFetchSuppliersResult => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["suppliers"],
    queryFn: async () => {
      const response = await v2GroupsList({
        query: { appId: PROOFING_FLOW_APP_ID, role: "supplier" },
      });
      return response.data;
    },
    enabled: options?.enabled ?? true,
  });

  return {
    suppliers: data || null,
    isLoading,
    error: error as Error | null,
  };
};
